import { ReactNode } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { CoreDataContextProvider } from 'src/app/contexts/useCoreDataContext';
import { Dictionaries } from 'src/pages/app/_BLL/metaDictionaries/types';
import { UserData } from 'src/pages/SignInPage/_BLL/types';

interface CoreData {
	dictionaries: Dictionaries;
}

interface Args {
	path: string;
	PageComponent: ReactNode;
	userData: UserData | null;
	coreData: CoreData | null;
	permission?: boolean;
}

export const renderRoute = ({ path, PageComponent, userData, coreData, permission = true }: Args) => {
	return (
		<Route
			path={path}
			element={
				userData ? (
					<>
						{coreData && permission ? (
							<CoreDataContextProvider
								userData={userData}
								dictionaries={coreData.dictionaries}
							>
								{PageComponent}
							</CoreDataContextProvider>
						) : (
							<>
								<span>{JSON.stringify(coreData)}</span>
							</>
						)}
					</>
				) : (
					<Navigate
						to="/"
						replace
					/>
				)
			}
		/>
	);
};
